var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app-outer"}},[_c('div',{ref:"scaleContainer",style:(_vm.scaleStyle),attrs:{"id":"app-scale-container"}},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }